// 交集
export function intersectionArr (arr, relation) {
  return arr.filter(function (v) {
    return relation.indexOf(v) > -1
  })
}

// 判断app的在第几列
export function estimateColumn (app, arr) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].includes(app)) {
      return i
    }
  }
}

// 判断app的左右两侧是否有连接线
export function hasRelationOrientation (app, arr, relation) {
  const column = estimateColumn(app, arr)
  const isOrientation = []
  if (column === 1) {
    const interLeft = intersectionArr(arr[0], relation)
    const interrRight = intersectionArr([...arr[2], ...arr[3]], relation)
    if (interLeft.length) {
      isOrientation.push('l1')
    }
    if (interrRight.length) {
      isOrientation.push('r1')
    }
  } else if (column === 2) {
    const interLeft = intersectionArr([...arr[0], ...arr[1]], relation)
    const interrRight = intersectionArr(arr[3], relation)
    if (interLeft.length) {
      isOrientation.push('l1')
    }
    if (interrRight.length) {
      isOrientation.push('r1')
    }
  }
  return isOrientation
}

// 排序
export function manageSortPoint (arr) {
  function ascend (x, y) {
    return x[0] - y[0] // 按照x轴升序排列
  }
  const sortArr = arr.sort(ascend)
  return sortArr
}

// 折线连接查找
export function managePolyline (app, arr, relation, allLine) {
  const coords = []
  const column = estimateColumn(app, arr)
  if (column === 0) {
    const tagratInflexionRight = allLine[app].r1 // 当前选中app的右边连接线
    const tagratInflexionLeftr1tol3 = allLine.r1tol3 // 第一列到第三列连接线
    const tagratInflexionLeft3r2tol4 = allLine.r2tol4 // 第二列到第四列连接线
    // 判断如何与其他连接点相连
    // 同列处理
    const inter0 = intersectionArr(arr[0], relation)
    // 第二列列所有点
    const inter1 = intersectionArr(arr[1], relation)
    // 第三列列所有点
    const inter2 = intersectionArr(arr[2], relation)
    // 第四列所有点
    const inter3 = intersectionArr(arr[3], relation)

    // 与第四列处理
    if (inter3.length) {
      const allPoint = [tagratInflexionLeft3r2tol4[1]] // 相邻的所有的点
      coords.push({
        coords: tagratInflexionLeft3r2tol4
      })
      inter3.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeft3r2tol4[1])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[1], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[1], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[1], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[1], sortPoints[sortPoints.length - 1]]
        })
      }
    }

    // 与第三列处理
    if (inter2.length) {
      const allPoint = [tagratInflexionLeftr1tol3[1]] // 相邻的所有的点
      if (inter3.length) {
        allPoint.push(tagratInflexionLeft3r2tol4[0])
      }
      coords.push({
        coords: tagratInflexionLeftr1tol3
      })
      inter2.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeftr1tol3[1])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeftr1tol3[1], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeftr1tol3[1], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeftr1tol3[1], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeftr1tol3[1], sortPoints[sortPoints.length - 1]]
        })
      }
    }
    if (inter2.length === 0 && inter3.length) {
      coords.push({
        coords: [tagratInflexionLeftr1tol3[1], tagratInflexionLeft3r2tol4[0]]
      })
    }

    // 与第二列处理
    if (inter1.length) {
      const allPoint = [tagratInflexionRight[1]] // 相邻的所有的点
      if (inter2.length) {
        allPoint.push(tagratInflexionLeftr1tol3[0])
      }
      inter1.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      // 加入自身的列
      inter0.forEach(item => {
        allPoint.push(allLine[item].r1[1])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionRight[1])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[sortPoints.length - 1]]
        })
      }
    }
    if (inter1.length === 0 && inter2.length) {
      coords.push({
        coords: tagratInflexionLeftr1tol3
      })
    }

    // 与第一列处理
    if (inter0.length && inter1.length === 0) {
      const allPoint = [tagratInflexionRight[1], tagratInflexionLeftr1tol3[0]]
      inter0.forEach(item => {
        allPoint.push(allLine[item].r1[1])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionRight[1])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[sortPoints.length - 1]]
        })
      }
    }
  } else if (column === 1) {
    const tagratInflexionLeft = allLine[app].l1 // 当前选中app的右边连接线
    const tagratInflexionRight = allLine[app].r1 // 当前选中app的右边连接线
    const tagratInflexionLeft3r2tol4 = allLine.r2tol4 // 第二列到第四列连接线
    // 判断如何与其他连接点相连
    // 同列处理
    const inter0 = intersectionArr(arr[0], relation)
    // 第二列列所有点
    const inter1 = intersectionArr(arr[1], relation)
    // 第三列列所有点
    const inter2 = intersectionArr(arr[2], relation)
    // 第四列所有点
    const inter3 = intersectionArr(arr[3], relation)

    // 与第一列处理
    if (inter0.length) {
      const allPoint = [tagratInflexionLeft[0]]
      inter0.forEach(item => {
        allPoint.push(allLine[item].r1[1])
      })
      // 加入自身的列
      inter1.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeft[0])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      }
    }

    // 与第二列处理
    if (inter0.length === 0 && inter1.length) {
      const allPoint = [tagratInflexionLeft[0]]
      inter1.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeft[0])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      }
    }

    // 与第三列处理
    if (inter2.length) {
      const allPoint = [tagratInflexionRight[1]] // 相邻的所有的点
      if (inter3.length) {
        allPoint.push(tagratInflexionLeft3r2tol4[0])
      }
      inter2.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionRight[1])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[sortPoints.length - 1]]
        })
      }
    }
    if (inter2.length === 0 && inter3.length) {
      coords.push({
        coords: tagratInflexionLeft3r2tol4
      })
      if (inter1.length === 0) {
        coords.push({
          coords: [tagratInflexionRight[1], tagratInflexionLeft3r2tol4[0]]
        })
      }
    }

    // 与第四列处理
    if (inter3.length) {
      const allPoint = [tagratInflexionLeft3r2tol4[1]] // 相邻的所有的点
      if (inter2.length && inter3.length) {
        coords.push({
          coords: tagratInflexionLeft3r2tol4
        })
      }
      inter3.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeft3r2tol4[1])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[1], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[1], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[1], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[1], sortPoints[sortPoints.length - 1]]
        })
      }
    }
  } else if (column === 2) {
    const tagratInflexionLeft = allLine[app].l1 // 当前选中app的左边连接线
    const tagratInflexionRight = allLine[app].r1 // 当前选中app的右边连接线
    const tagratInflexionLeftr1tol3 = allLine.r1tol3 // 第三列到第一列连接线
    // 判断如何与其他连接点相连
    // 同列处理
    const inter0 = intersectionArr(arr[0], relation)
    // 第二列列所有点
    const inter1 = intersectionArr(arr[1], relation)
    // 第三列列所有点
    const inter2 = intersectionArr(arr[2], relation)
    // 第四列所有点
    const inter3 = intersectionArr(arr[3], relation)

    // 与第四列处理
    if (inter3.length) {
      const allPoint = [tagratInflexionRight[1]]
      inter3.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionRight[1])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionRight[1], sortPoints[sortPoints.length - 1]]
        })
      }
    }
    // 与第三列处理
    if (inter1.length === 0 && inter2.length) {
      const allPoint = [tagratInflexionLeft[0]]
      inter2.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeft[0])
      if (index === 0) {
        coords.push({
          coords: [sortPoints[sortPoints.length - 1], tagratInflexionLeft[0]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      }
    }
    // 与第二列处理
    if (inter1.length) {
      const allPoint = [tagratInflexionLeft[0]]
      inter1.forEach(item => {
        allPoint.push(allLine[item].r1[1])
      })
      // 加入自身的列
      inter2.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeft[0])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      }
    }
    if (inter1.length === 0 && inter0.length) {
      coords.push({
        coords: tagratInflexionLeftr1tol3
      })
      if (inter2.length === 0) {
        coords.push({
          coords: [tagratInflexionLeftr1tol3[1], tagratInflexionLeft[0]]
        })
      }
    }
    // 与第一列处理
    if (inter0.length) {
      const allPoint = [tagratInflexionLeftr1tol3[0]] // 相邻的所有的点
      if (inter1.length && inter0.length) {
        coords.push({
          coords: tagratInflexionLeftr1tol3
        })
      }
      inter0.forEach(item => {
        allPoint.push(allLine[item].r1[1])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeftr1tol3[0])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeftr1tol3[0], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeftr1tol3[0], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeftr1tol3[0], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeftr1tol3[0], sortPoints[sortPoints.length - 1]]
        })
      }
    }
  } else if (column === 3) {
    const tagratInflexionLeft = allLine[app].l1 // 当前选中app的右边连接线
    const tagratInflexionLeftr1tol3 = allLine.r1tol3 // 第一列到第三列连接线
    const tagratInflexionLeft3r2tol4 = allLine.r2tol4 // 第二列到第四列连接线
    // 同列处理
    const inter0 = intersectionArr(arr[0], relation)
    // 第二列列所有点
    const inter1 = intersectionArr(arr[1], relation)
    // 第三列列所有点
    const inter2 = intersectionArr(arr[2], relation)
    // 第四列所有点
    const inter3 = intersectionArr(arr[3], relation)

    // 与第四列处理
    if (inter3.length && inter2.length === 0) {
      const allPoint = [tagratInflexionLeft[0], tagratInflexionLeftr1tol3[1]]
      inter3.forEach(item => {
        allPoint.push(allLine[item].r1[1])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeft[0])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      }
    }

    // 与第三列处理
    if (inter2.length) {
      const allPoint = [tagratInflexionLeft[0]] // 相邻的所有的点
      if (inter1.length) {
        allPoint.push(tagratInflexionLeft3r2tol4[1])
      }
      inter2.forEach(item => {
        allPoint.push(allLine[item].r1[1])
      })
      // 加入自身的列
      inter3.forEach(item => {
        allPoint.push(allLine[item].l1[0])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeft[0])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeft[0], sortPoints[sortPoints.length - 1]]
        })
      }
    }
    if (inter2.length === 0 && inter1.length) {
      coords.push({
        coords: tagratInflexionLeftr1tol3
      })
    }

    // 与第二列处理
    if (inter1.length) {
      const allPoint = [tagratInflexionLeft3r2tol4[0]] // 相邻的所有的点
      if (inter0.length) {
        allPoint.push(tagratInflexionLeftr1tol3[1])
      }
      coords.push({
        coords: tagratInflexionLeft3r2tol4
      })
      inter1.forEach(item => {
        allPoint.push(allLine[item].r1[1])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeft3r2tol4[0])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[0], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[0], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[0], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeft3r2tol4[0], sortPoints[sortPoints.length - 1]]
        })
      }
    }
    if (inter3.length === 0 && inter2.length) {
      coords.push({
        coords: [tagratInflexionLeft3r2tol4[0], tagratInflexionLeftr1tol3[1]]
      })
    }

    // 与第一列处理
    if (inter0.length) {
      const allPoint = [tagratInflexionLeftr1tol3[0]] // 相邻的所有的点
      coords.push({
        coords: tagratInflexionLeftr1tol3
      })
      inter0.forEach(item => {
        allPoint.push(allLine[item].r1[1])
      })
      const sortPoints = manageSortPoint(allPoint)
      const index = sortPoints.indexOf(tagratInflexionLeftr1tol3[0])
      if (index === 0) {
        coords.push({
          coords: [tagratInflexionLeftr1tol3[0], sortPoints[sortPoints.length - 1]]
        })
      } else if (index === sortPoints.length - 1) {
        coords.push({
          coords: [tagratInflexionLeftr1tol3[0], sortPoints[0]]
        })
      } else {
        coords.push({
          coords: [tagratInflexionLeftr1tol3[0], sortPoints[0]]
        })
        coords.push({
          coords: [tagratInflexionLeftr1tol3[0], sortPoints[sortPoints.length - 1]]
        })
      }
    }
  }
  return coords
}
